// extracted by mini-css-extract-plugin
export default {"projectWrapper":"project_projectWrapper__Mz3DR","projectBackground":"project_projectBackground__FJEGr","projectTop":"project_projectTop__vuKEd"};